import { createFileRoute } from '@tanstack/react-router';

import { ProtectedRoute } from '@/components';
import ContractsDashboard from '@/pages/ContractsDashboard';

export const Route = createFileRoute('/contrats')({
  component: () => (
    <ProtectedRoute>
      <ContractsDashboard />
    </ProtectedRoute>
  ),
});
